const BrandCatalog = () => import('./Catalog')
const BrandSlider = () => import('./Slider')

export default function install(Vue) {
  Vue.component('brand-catalog', BrandCatalog)
  Vue.component('brand-slider', BrandSlider)
}
